import { createAction, props } from '@ngrx/store';
import { ContentPage } from '../../models';

export const LoadContentPages = createAction('[Content] Load Content Pages');
export const LoadContentPagesSuccess = createAction('[Content] Load Content Pages Success', props<{ contentPages: ContentPage[] }>());
export const LoadContentPagesFail = createAction('[Content] Load Content Pages Fail', props<{ error: any }>());

export const LoadContentPage = createAction('[Content] Load Content Page', props<{ id: number }>());
export const LoadContentPageSuccess = createAction('[Content] Load Content Page Success', props<{ page: ContentPage }>());
export const LoadContentPageFail = createAction('[Content] Load Content Page Fail', props<{ error: any }>());

export const LoadSubContentPages = createAction('[Content] Load Sub Content Pages', props<{ id: number }>());
export const LoadSubContentPagesSuccess = createAction(
  '[Content] Load Sub Content Pages Success',
  props<{ contentPages: ContentPage[] }>()
);
export const LoadSubContentPagesFail = createAction('[Content] Load Sub Content Pages Fail', props<{ error: any }>());

export const ClearSubPages = createAction('[Content] Clear Sub Pages');
